import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EchartsRoutingModule } from './echarts-routing.module';
import { SharedModule } from '../shared/shared.module';
import { IndexComponent } from './2022/index';



@NgModule({
  declarations: [
    IndexComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    EchartsRoutingModule,
  ]
})
export class EchartsModule { }
